import FactoryComponents from '../../../../factory/components/FactoryComponents.js';
import RoleManager from '../../../components/home/manager/RoleManager.vue';
const root = {}
export default root
root.name='companyManager';

root.data = {

	thisName: '',
	menuDatas:[],
	defaultChooseTitle: '',
	navIcon: ['icon-zhangdan', 'icon--_weixiugongdan', 'icon-baoxiu1', 'icon-xinxiweihu', 'icon-guzhangbaoxiu', 'icon-leimupinleifenleileibie']

};

root.methods = {
	returnHome: function(){
		this.$router.push({ path: "/home" })
	},
	routerConfig: function(menuDatas){
		const menuDatasConfig = {...menuDatas};
		menuDatasConfig.childMenu = [];
		//针对企业管理进行二级路由配置
		// menuDatas.childMenu.forEach((item, index)=>{
		menuDatas.forEach((item, index)=>{
			// if(item.hasAuth){
				if(item.menuName === '设备分类'){
					item.routerUri = '/equipmentManager/equipmentTypeManager';
				}
				if(item.menuName === '设备台账'){
					item.routerUri = '/equipmentManager/equipmentLedgerManager';
				}
				if(item.menuName === '故障报修'){
					item.routerUri = '/equipmentManager/equipmentFaultManager';
				}
				if(item.menuName === '信息维护'){
					item.routerUri = '/equipmentManager/equipmentInfoManager';
				}
				if(item.menuName === '报修处理'){
					item.routerUri = '/equipmentManager/equipmentLedgerHandlerManager';
				}
				if(item.menuName === '维修工单'){
					item.routerUri = '/equipmentManager/equipmentOrderManager';
				}
				this.componentsMoudel.setData(item.routerUri, item);
				menuDatasConfig.childMenu.push(item);
			// }

		});
		return menuDatasConfig;
	},
};
root.mounted = function(){
	// let menuDatas = this.componentsMoudel.getData("/equipmentManager");
	let menuDatas = [{menuName:"设备分类"},{menuName:"设备台账"},{menuName:"故障报修"},{menuName:"信息维护"},{menuName:"报修处理"},{menuName:"维修工单"}];//this.componentsMoudel.getData("/equipmentManager/equipmentLedgerManager");
	if(menuDatas === undefined){
		this.$router.push({ path: '/home' });
	}
	this.thisName = menuDatas.menuName;

	const menuDatas2 = this.routerConfig(menuDatas);
	this.menuDatas = menuDatas2.childMenu;

	// if(this.$route.path === "/equipmentManager"){
	if(this.$route.path === "/equipmentManager/equipmentLedgerManager"){
		this.defaultChooseTitle = menuDatas2.childMenu[0].routerUri
		this.$router.push({ path: this.defaultChooseTitle })
	}else{
		this.defaultChooseTitle = this.$route.path;
	}
};

FactoryComponents.initComponent(root);
